/* hlk.js · V4 · Smooth by Ceylo · JS וניל, בלי ספריות.
   1) שפת תנועה בגלילה: .hlk-reveal (מדורג), .hlk-rise (עלייה גדולה), .hlk-zoom (תמונה שמתייצבת)
   2) פס קנייה צף
   3) מונים רצים: [data-hlk-count] וגם שורת ההוכחה
   4) אנטומיית המוצר
   5) פרלקסה בשתי עוצמות: [data-hlk-plx] / [data-hlk-plx="strong"]
   הכל כבוי אוטומטית ב-reduced-motion ובעורך, ונטען מחדש ב-shopify:section:load. */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var canAnimate = !reduced && 'IntersectionObserver' in window;

  var revealObserver = null;
  if (canAnimate) {
    document.documentElement.classList.add('hlk-anim');
    revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); revealObserver.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px 14% 0px' });
  }
  /* בעורך של שופיפיי: רשת ביטחון. כל מה שלא נחשף תוך שנייה וחצי נחשף בכוח,
     כדי שאף פעם לא יישאר תוכן מוסתר בזמן עריכה. */
  function safetyReveal(scope) {
    if (!designMode) return;
    setTimeout(function () {
      (scope || document).querySelectorAll('.hlk-reveal:not(.is-in), .hlk-rise:not(.is-in), .hlk-zoom:not(.is-in)')
        .forEach(function (el) { el.classList.add('is-in'); });
    }, 1500);
  }

  function initReveal(root) {
    if (!canAnimate) return;
    var scope = root || document;
    var counts = {};
    scope.querySelectorAll('.hlk-reveal:not(.is-in), .hlk-rise:not(.is-in)').forEach(function (el) {
      var sec = el.closest('.shopify-section, section, body');
      var key = sec ? (sec.id || 'x') : 'x';
      counts[key] = (counts[key] || 0) + 1;
      el.style.transitionDelay = Math.min((counts[key] - 1) * 60, 300) + 'ms';
      revealObserver.observe(el);
    });
    scope.querySelectorAll('.hlk-zoom:not(.is-in)').forEach(function (el) { revealObserver.observe(el); });
    safetyReveal(scope);
  }

  var stickyObserver = null;
  function initSticky() {
    var sticky = document.querySelector('[data-hlk-sticky]');
    if (!sticky) return;
    if (stickyObserver) { stickyObserver.disconnect(); stickyObserver = null; }
    var watched = document.querySelector(sticky.getAttribute('data-watch') || '[data-hlk-buybox]');
    if (designMode || !watched || !('IntersectionObserver' in window)) {
      sticky.classList.add('is-visible');
      return;
    }
    stickyObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    stickyObserver.observe(watched);
  }

  function animateCount(el) {
    if (el.dataset.hlkCounted) return;
    el.dataset.hlkCounted = '1';
    var original = el.textContent;
    var m = original.replace(/,/g, '').match(/(\d+(?:\.\d+)?)/);
    if (!m) return;
    var target = parseFloat(m[1]);
    var decimals = (m[1].split('.')[1] || '').length;
    var start = null, dur = 2000;
    function fmt(v) {
      var s = v.toFixed(decimals);
      if (decimals === 0) s = s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return original.replace(/[\d,]+(?:\.\d+)?/, s);
    }
    function tick(t) {
      if (!start) start = t;
      var p = Math.min((t - start) / dur, 1);
      p = 1 - Math.pow(1 - p, 3);
      el.textContent = fmt(target * p);
      if (p < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }
  function initCounters(root) {
    if (!canAnimate) return;
    var els = (root || document).querySelectorAll('[data-hlk-count], .hlk-strip__item .hlk-num');
    if (!els.length) return;
    var co = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { animateCount(e.target); co.unobserve(e.target); }
      });
    }, { threshold: 0.5 });
    els.forEach(function (el) { co.observe(el); });
  }

  function initAnatomy(root) {
    (root || document).querySelectorAll('[data-hlk-anatomy]').forEach(function (box) {
      if (box.dataset.hlkReady) return;
      box.dataset.hlkReady = '1';
      var items = box.querySelectorAll('[data-hlk-part]');
      var dots = box.querySelectorAll('[data-hlk-dot]');
      if (!items.length) return;
      function activate(i) {
        items.forEach(function (el) { el.classList.toggle('is-active', el.getAttribute('data-hlk-part') == i); });
        dots.forEach(function (el) { el.classList.toggle('is-active', el.getAttribute('data-hlk-dot') == i); });
      }
      activate(0);
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var i = dot.getAttribute('data-hlk-dot');
          activate(i);
          var item = box.querySelector('[data-hlk-part="' + i + '"]');
          if (item) item.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
        });
      });
      items.forEach(function (item) {
        item.addEventListener('click', function () { activate(item.getAttribute('data-hlk-part')); });
      });
      if ('IntersectionObserver' in window && !designMode) {
        var ao = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) activate(e.target.getAttribute('data-hlk-part'));
          });
        }, { rootMargin: '-40% 0px -40% 0px' });
        items.forEach(function (item) { ao.observe(item); });
      }
    });
  }

  var plxBound = false;
  function initParallax() {
    if (!canAnimate) return;
    function update() {
      var vh = window.innerHeight;
      document.querySelectorAll('[data-hlk-plx]').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        var strong = el.getAttribute('data-hlk-plx') === 'strong';
        var factor = strong ? -0.07 : -0.032;
        var cap = strong ? 34 : 14;
        var center = r.top + r.height / 2 - vh / 2;
        var y = Math.max(-cap, Math.min(cap, center * factor));
        el.style.transform = 'translate3d(0,' + y.toFixed(1) + 'px,0)';
      });
    }
    if (!plxBound) {
      plxBound = true;
      var ticking = false;
      window.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; requestAnimationFrame(function () { ticking = false; update(); }); }
      }, { passive: true });
      window.addEventListener('resize', update, { passive: true });
    }
    update();
  }


  /* --- 6: פתיחת מגירת העגלה ---
     בקובץ header.liquid של שריין ה-id שפותח את המגירה הועבר מהקישור עצמו ל-div פנימי,
     ולכן הקליק על אייקון העגלה בורח ל-/cart במקום לפתוח פופאפ.
     כאן אנחנו קושרים מחדש, בלי לגעת בקבצי הליבה של שריין. */
  function hlkCartDrawer() {
    var drawer = document.querySelector('cart-drawer') || document.getElementById('CartDrawer');
    if (!drawer) return null;
    if (drawer.classList && drawer.classList.contains('is-empty')) return drawer;
    return drawer;
  }
  function hlkOpenCart(e) {
    var drawer = hlkCartDrawer();
    if (!drawer) return;                      /* אין מגירה בערכה, נותנים לקישור לעבוד */
    var host = document.querySelector('cart-drawer');
    if (host && typeof host.open === 'function') {
      e.preventDefault();
      host.open(e.currentTarget);
      return;
    }
    var box = document.getElementById('CartDrawer');
    if (box) {
      e.preventDefault();
      box.classList.add('animate', 'active');
      document.body.classList.add('overflow-hidden');
      var closer = box.querySelector('[id*="Close"], .drawer__close, button[aria-label]');
      if (closer) { try { closer.focus(); } catch (err) {} }
    }
  }
  function initCartOpener() {
    if (designMode) return;
    document.querySelectorAll('a.header__icon--cart, a[href$="/cart"].header__icon').forEach(function (el) {
      if (el.dataset.hlkCartBound) return;
      el.dataset.hlkCartBound = '1';
      el.addEventListener('click', hlkOpenCart);
    });
  }


  /* --- 7: הוספה לסל בלי לעזוב את העמוד ---
     הטופס של הסקשן "מוצר · קנייה" הוא טופס מוצר רגיל של שופיפיי, ולכן שליחה רגילה
     זורקת את הגולש לעמוד /cart. כאן שולחים ברקע, מרעננים את תוכן המגירה ופותחים אותה.
     אם אין מגירה בעמוד (למשל כשהעגלה מוגדרת כעמוד), לא נוגעים בכלום והטופס עובד כרגיל. */
  var HLK_CART_SECTIONS = [
    { id: 'cart-drawer', selector: '#CartDrawer' },
    { id: 'cart-icon-bubble' }
  ];

  function hlkSectionsToRender(drawer) {
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      try {
        var list = drawer.getSectionsToRender();
        if (list && list.length) return list;
      } catch (err) {}
    }
    return HLK_CART_SECTIONS;
  }

  function hlkSectionInnerHTML(html, selector) {
    try {
      var el = new DOMParser().parseFromString(html, 'text/html').querySelector(selector || '.shopify-section');
      return el ? el.innerHTML : null;
    } catch (err) { return null; }
  }

  function hlkPaintCart(drawer, state) {
    hlkSectionsToRender(drawer).forEach(function (section) {
      var html = state.sections && state.sections[section.id];
      if (!html) return;
      var target = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      if (!target) return;
      var inner = hlkSectionInnerHTML(html, section.selector);
      if (inner !== null) target.innerHTML = inner;
    });
    /* העגלה כבר לא ריקה */
    drawer.classList.remove('is-empty');
    var innerBox = drawer.querySelector('.drawer__inner');
    if (innerBox) innerBox.classList.remove('is-empty');
    /* הרקע הכהה נוצר מחדש יחד עם התוכן, אז קושרים לו סגירה */
    hlkSubNotice();
    var overlay = document.getElementById('CartDrawer-Overlay');
    if (overlay && !overlay.dataset.hlkBound) {
      overlay.dataset.hlkBound = '1';
      overlay.addEventListener('click', function () {
        if (typeof drawer.close === 'function') drawer.close();
      });
    }
  }

  function hlkFormError(form, message) {
    var box = form.querySelector('[data-hlk-form-error]');
    if (!box) {
      if (!message) return;
      box = document.createElement('p');
      box.setAttribute('data-hlk-form-error', '');
      box.setAttribute('role', 'alert');
      box.style.cssText = 'margin:10px 0 0;font-size:0.9rem;line-height:1.4;color:#B3261E;';
      form.appendChild(box);
    }
    box.textContent = message || '';
    box.hidden = !message;
  }

  function hlkFormButtons(form) {
    return Array.prototype.filter.call(form.elements || [], function (el) {
      return el.type === 'submit';
    });
  }

  function hlkSubmitToCart(e) {
    var form = e.currentTarget;
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;                      /* אין מגירה: שליחה רגילה ל-/cart */
    e.preventDefault();
    if (form.dataset.hlkBusy) return;
    form.dataset.hlkBusy = '1';

    var trigger = e.submitter || form.querySelector('button[type="submit"]');
    var buttons = hlkFormButtons(form);
    buttons.forEach(function (b) {
      b.dataset.hlkWasDisabled = b.disabled ? '1' : '';
      b.disabled = true;
      b.setAttribute('aria-busy', 'true');
    });
    hlkFormError(form, '');

    var sectionsParam = hlkSectionsToRender(drawer).map(function (s) { return s.id; }).join(',');
    var planInput = form.querySelector('[data-hlk-addon]:checked');
    var addonId = planInput ? planInput.getAttribute('data-hlk-addon') : null;
    var idField = form.querySelector('[name="id"]:checked') || form.querySelector('[name="id"]');
    var mainId = idField ? idField.value : null;
    var qtyField = form.querySelector('[name="quantity"]');
    var qty = qtyField ? (parseInt(qtyField.value, 10) || 1) : 1;

    var reqHeaders, reqBody;
    if (addonId && mainId) {
      /* מנוי נבחר: מוסיפים את המכונה ואת המוצר המתחדש בבקשה אחת */
      reqHeaders = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
      reqBody = JSON.stringify({
        items: [
          { id: Number(mainId), quantity: qty },
          { id: Number(addonId), quantity: 1 }
        ],
        sections: sectionsParam,
        sections_url: window.location.pathname
      });
    } else {
      var fd = new FormData(form);
      fd.append('sections', sectionsParam);
      fd.append('sections_url', window.location.pathname);
      reqHeaders = { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' };
      reqBody = fd;
    }

    var addUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';

    function release() {
      delete form.dataset.hlkBusy;
      buttons.forEach(function (b) {
        b.disabled = b.dataset.hlkWasDisabled === '1';
        b.removeAttribute('aria-busy');
        delete b.dataset.hlkWasDisabled;
      });
    }

    fetch(addUrl + '.js', {
      method: 'POST',
      headers: reqHeaders,
      body: reqBody
    })
      .then(function (res) { return res.json(); })
      .then(function (json) {
        if (!json || json.status) {           /* 422 וכדומה: אזל מהמלאי, כמות לא זמינה */
          hlkFormError(form, (json && (json.description || json.message)) || 'לא הצלחנו להוסיף לסל.');
          return;
        }
        if (json.sections) hlkPaintCart(drawer, json);
        if (trigger && typeof drawer.setActiveElement === 'function') {
          try { drawer.setActiveElement(trigger); } catch (err) {}
        }
        if (typeof drawer.open === 'function') {
          drawer.open(trigger);
        } else {
          var box = document.getElementById('CartDrawer');
          if (box) {
            box.classList.add('animate', 'active');
            document.body.classList.add('overflow-hidden');
          }
        }
        /* מודיעים לשאר הערכה שהעגלה השתנתה (פסי משלוח חינם, מונה פריטים וכו') */
        try {
          if (window.publish && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
              source: 'hlk-product-form',
              productVariantId: mainId,
              cartData: json
            });
          }
        } catch (err) {}
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      })
      .catch(function () {
        hlkFormError(form, (window.cartStrings && window.cartStrings.error) || 'משהו השתבש. נסו שוב.');
      })
      .then(release, release);
  }

  /* בורר "מנוי מול רכישה חד פעמית": סימון ויזואלי והצגת משפט ההסכמה */
  function initPlans(root) {
    (root || document).querySelectorAll('[data-hlk-plans]').forEach(function (box) {
      if (box.dataset.hlkPlansBound) return;
      box.dataset.hlkPlansBound = '1';
      function sync() {
        box.querySelectorAll('[data-hlk-plan]').forEach(function (label) {
          var input = label.querySelector('input[type="radio"]');
          label.classList.toggle('is-selected', !!(input && input.checked));
        });
        var sub = box.querySelector('[data-hlk-plan-kind="subscribe"]');
        var onSub = !!(sub && sub.checked);
        var scope = box.closest('.hlk-pdp__box') || document;
        ['[data-hlk-consent]', '[data-hlk-plan-note]', '[data-hlk-plan-perks]'].forEach(function (sel) {
          var el = scope.querySelector(sel);
          if (el) el.hidden = !onSub;
        });
      }
      box.addEventListener('change', sync);
      sync();
    });
  }

  /* --- 8: הצהרת החיוב החוזר במגירת העגלה ---
     מופיעה רק כשיש בעגלה מוצר מנוי, ומצהירה במפורש על הסכום, התדירות ואיך מבטלים.
     כל הטקסט מרוכז כאן, כדי שיהיה קל לשנות אותו במקום אחד. */
  var HLK_SUB = {
    handles: ['smooth-club'],
    heading: 'העגלה שלך כוללת מנוי מתחדש.',
    body: 'בלחיצה על "תשלום" אתם מאשרים במפורש שכרטיס האשראי יישמר ויחויב אוטומטית ב-<strong>69 ₪ בלבד, אחת ל-6 שבועות</strong> — על ראש הגילוח בלבד. המכונה נקנית פעם אחת ולא מחויבת שוב. החיוב הראשון מתבצע כשישה שבועות לאחר ההזמנה, ומאותו רגע אפשר לדלג, להשהות או לבטל בכל עת דרך החשבון או בפנייה אלינו. יש לעיין ב<a href="/policies/refund-policy">מדיניות הביטולים</a>.'
  };

  function hlkSubNotice() {
    var btn = document.getElementById('CartDrawer-Checkout');
    if (!btn || !btn.parentNode) return;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var hasSub = (cart.items || []).some(function (item) {
          return HLK_SUB.handles.indexOf(item.handle) > -1;
        });
        var box = document.querySelector('[data-hlk-sub-notice]');
        if (!hasSub) { if (box) box.parentNode.removeChild(box); return; }
        if (box) return;
        box = document.createElement('div');
        box.setAttribute('data-hlk-sub-notice', '');
        box.style.cssText = 'margin:0 0 12px;font-size:1.2rem;line-height:1.55;text-align:right;';
        box.innerHTML = '<strong>' + HLK_SUB.heading + '</strong> ' + HLK_SUB.body;
        btn.parentNode.insertBefore(box, btn);
      })
      .catch(function () {});
  }

  function initBuyForm(root) {
    (root || document).querySelectorAll('form[id^="hlk-form-"], form.hlk-pdp__form').forEach(function (form) {
      if (form.dataset.hlkAtcBound) return;
      form.dataset.hlkAtcBound = '1';
      form.addEventListener('submit', hlkSubmitToCart);
    });
  }

  function initAll(root) {
    initReveal(root);
    initSticky();
    initCounters(root);
    initAnatomy(root);
    initParallax();
    initCartOpener();
    initBuyForm(root);
    initPlans(root);
    hlkSubNotice();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:select', function (e) { initAll(e.target); });
})();
